import React from 'react';
export const EditIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M8.769 20.5H4.253a.753.753 0 0 1-.753-.753v-4.204c0-.2.08-.391.22-.532L15.01 3.72a.753.753 0 0 1 1.065 0l4.204 4.204a.753.753 0 0 1 0 1.064L8.77 20.5z'
        fill='#E0C1FF'
        stroke='var(--theme-primary, #810ea9)'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path d='m12 8 3.5 3.5' stroke='var(--theme-primary, #810ea9)' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
  );
};
